<template>
  <div id="customerData">

    
    <!-- Card body -->
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form
        class="needs-validation"
        @submit.prevent="handleSubmit(firstFormSubmit)"
      >



        <b-row>

                  <b-col md="6">
                    <h4>Abweichender Halter</h4>
                                <base-input rules="required" name="Titel">
              <el-select 
                v-model="offer.holder_title"
                filterable
                placeholder="Titel"
              >
                <el-option
                  v-for="option in offer.customer_titles"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>

                  </b-col>



        </b-row>

        <b-row>

                  <b-col md="6">
                    <h4>Vorname</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="Vorname" v-model="offer.holder_firstname" name="Vorname" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>

                  <b-col md="6">
                     <h4>Nachname</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="Nachname" v-model="offer.holder_lastname" name="Nachname" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>


         </b-row>

        <b-row>

                  <b-col md="6">
                    <h4>Strasse</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="Strasse" v-model="offer.holder_street" name="Strasse" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>

                  <b-col md="6">
                     <h4>Hausnummer</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="Hausnummer" v-model="offer.holder_number" name="Hausnummer" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>


         </b-row>


        <b-row>

                  <b-col md="6">
                    <h4>PLZ</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="PLZ" v-model="offer.holder_zip" name="PLZ" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>

                  <b-col md="6">
                     <h4>Ort</h4>
                    <base-input prepend-icon="fas fa-university" placeholder="Ort" v-model="offer.holder_city" name="Ort" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
                  </b-col>


         </b-row>


      </form>
    </validation-observer>
  </div>




  
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "holder",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: false,
      countries: [],
    };
  },
  methods: {
    getZipFromSelection(klid){
      this.offer.customer_zip = this.options.find( zip => zip.value === klid).plz;
      this.offer.customer_city = this.options.find( zip => zip.value === klid).label;
    },
        toggleHolder: function(){
            this.showHolder = !this.showHolder;
        },
        currentHolder: function(){
          this.offer.KRAVAG_HOLDERS_CAR.find(holder => {
          if (holder.value === this.offer.holder_id) {
            this.writtenHolder = holder.label;
            
          }
        })
        },

    fetchCountries() {
      this.loading = true;
      this.$api
        .getCountries()
        .then((response) => {
          this.countries = response.data.items.map((item) => {
            return { value: item.id, label: item.value };
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    searchCountries(query) {
      if (query !== "") {
        this.loading = true;
        this.$api
          .getCountries(query)
          .then((response) => {
            console.log(response.data.items);
            this.countries = [];
            this.countries = response.data.items.map((item) => {
              return { value: item.value, label: item.id };
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

  },
  watch: {
    holder(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.currentHolder();
      this.toggleHolder();
      // Do whatever makes sense now
      if (newValue === 'success') {
        this.complex = {
          deep: 'some deep object',
        };
      }
      if (newValue != 'N') {
        this.offer.has_holder = true;
      }
      else{
        this.offer.has_holder = false;
        this.offer.holder_kravag_location_id = '';
      }
    },
},
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
    }),
  },
  mounted() {
      this.fetchCountries();
  },
};
</script>
<style>
</style>